export const handleSubmitForm = (values, onAddClaim) => {
  const breakdownId =
    typeof values.breakdownId === 'object' && values.breakdownId !== null
      ? values.breakdownId.value
      : values.breakdownId;
  const breakdownSubId =
    typeof values.breakdownSubId === 'object' && values.breakdownSubId !== null
      ? values.breakdownSubId.value
      : values.breakdownSubId;

  const rawMobileIds = values.warrantyMobileIds;
  const warrantyMobileIds = Array.isArray(rawMobileIds)
    ? rawMobileIds.map((x) => (typeof x === 'object' && x !== null && 'value' in x ? x.value : x))
    : [];

  const uploadData = {
    claimImage: values.claimImage ? values.claimImage[0] : null,
    receiptImage: values.receiptImage ? values.receiptImage[0] : null,
    warrantyId: values.warrantyId,
    customerCode: values.customerCode,
    detail1: values.detail1,
    detail2: values.detail2,
    breakdownId,
    breakdownSubId,
    warrantyMobileIds,
    warrantyMobileOtherReason: values.warrantyMobileOtherReason || '',
    addressLine1: values.addressLine1,
    addressLine2: values.addressLine2,
    subDistrictId: values.subDistrictId,
    zipcode: values.zipcode,
    other: values.other,
    isCreateNewAddress: values.isCreateNewAddress,
  };

  onAddClaim(uploadData);
};
